const translations = {
  pt: {
    'hello': 'Olá,',
    'i-am': 'Eu sou',
    'role': 'Desenvolvedor Full-Stack',
    'skills-title': 'Habilidades e Ferramentas',
    'skills-description': 'Principais ferramentas e tecnologias utilizadas até o momento no desenvolvimento de projetos e soluções.',
    'projects-title': 'Projetos',
    'projects-description': 'Alguns projetos desenvolvidos durante minha jornada como desenvolvedor.',
    'tcc-express-supermarket': 'TCC - Express Supermarket',
    'tcc-project-description': 'Sistema de e-commerce desenvolvido como Trabalho de Conclusão de Curso, integrado com scanner de código de barras e localização de produtos.',
    'key-features': 'Características Principais:',
    'feature-ecommerce': 'Sistema completo de e-commerce',
    'feature-barcode': 'Scanner de código de barras integrado',
    'feature-location': 'Sistema de localização de produtos',
    'traitus-gamer': 'Traitus Gamer Landing Page',
    'traitus-description': 'Landing page moderna desenvolvida com tecnologias frontend avançadas, focada em performance e experiência do usuário.',
    'traitus-feature-1': 'CSS Grid e Flexbox para layouts responsivos',
    'traitus-feature-2': 'JavaScript ES6+ Vanilla sem dependências',
    'traitus-feature-3': 'Sistema de internacionalização (3 idiomas)',
    'cs2-team-portfolio': 'CS2 - Equipe e Integração com a Steam',
    'cs2-description': 'Plataforma completa para Counter-Strike 2 com integração em tempo real da Steam API, visualização de inventários dos players, mercado Steam com preços atualizados em BRL e sistema de áudio imersivo.',
    'cs2-feature-1': 'Mercado Steam em tempo real com conversão USD→BRL',
    'cs2-feature-2': 'Visualizador de inventários com dados reais dos players',
    'cs2-feature-3': 'Sistema de busca avançado com tradução para português',
    'cs2-feature-4': 'Interface moderna com navegação por abas e modais',
    'cs2-feature-5': 'Sistema de áudio interativo com efeitos CS2',
    'weather-project': 'Previsão do Tempo em Tempo Real',
    'weather-description': 'Aplicação de clima com dados em tempo real da Open-Meteo, busca de cidades com sugestões instantâneas e fundo animado em WebGL que reage ao clima atual: sol, chuva, neve, neblina e tempestades com raios.',
    'weather-feature-1': 'Fundo animado com Three.js (WebGL) conforme o clima e o vento',
    'weather-feature-2': 'Gráfico interativo de temperatura e chuva das próximas 24h',
    'weather-feature-3': 'Busca de cidades com autocomplete em tempo real',
    'weather-feature-4': 'Previsão de 14 dias e mapa interativo com Leaflet',
    'view-project': 'Ver Projeto',
    'image-coming-soon': 'Imagem em breve',
    'contact-title': 'Entre em Contato',
    'contact-description': 'Vamos conversar sobre seu próximo projeto!',
    'contact-us': 'Contate-me'
  },
  en: {
    'hello': 'Hello,',
    'i-am': 'I am',
    'role': 'Full-Stack Developer',
    'skills-title': 'Skills and Tools',
    'skills-description': 'Main tools and technologies used to date in the development of projects and solutions.',
    'projects-title': 'Projects',
    'projects-description': 'Some projects developed during my journey as a developer.',
    'tcc-express-supermarket': 'TCC - Express Supermarket',
    'tcc-project-description': 'E-commerce system developed as a Course Completion Project, integrated with barcode scanner and product location.',
    'key-features': 'Key Features:',
    'feature-ecommerce': 'Complete e-commerce system',
    'feature-barcode': 'Integrated barcode scanner',
    'feature-location': 'Product location system',
    'traitus-gamer': 'Traitus Gamer Landing Page',
    'traitus-description': 'Modern landing page developed with advanced frontend technologies, focused on performance and user experience.',
    'traitus-feature-1': 'CSS Grid and Flexbox for responsive layouts',
    'traitus-feature-2': 'Vanilla JavaScript ES6+ without dependencies',
    'traitus-feature-3': 'Internationalization system (3 languages)',
    'cs2-team-portfolio': 'CS2- Team and Steam Integration',
    'cs2-description': 'Complete Counter-Strike 2 platform with real-time Steam API integration, player inventory visualization, Steam market with live BRL pricing and immersive audio system.',
    'cs2-feature-1': 'Real-time Steam Market with USD→BRL conversion',
    'cs2-feature-2': 'Real player inventory viewer with live data',
    'cs2-feature-3': 'Advanced search system with Portuguese translations',
    'cs2-feature-4': 'Modern interface with tab navigation and modals',
    'cs2-feature-5': 'Interactive audio system with CS2 sound effects',
    'weather-project': 'Real-Time Weather Forecast',
    'weather-description': 'Weather app with real-time Open-Meteo data, instant city search suggestions and a WebGL animated background that reacts to current conditions: sun, rain, snow, fog and lightning storms.',
    'weather-feature-1': 'Three.js (WebGL) animated background driven by weather and wind',
    'weather-feature-2': 'Interactive 24-hour temperature and rain chart',
    'weather-feature-3': 'City search with real-time autocomplete',
    'weather-feature-4': '14-day forecast and interactive Leaflet map',
    'view-project': 'View Project',
    'image-coming-soon': 'Image coming soon',
    'contact-title': 'Get in Touch',
    'contact-description': "Let's talk about your next project!",
    'contact-us': 'Contact me'
  },
  es: {
    'hello': 'Hola,',
    'i-am': 'Soy',
    'role': 'Desarrollador Full-Stack',
    'skills-title': 'Habilidades y Herramientas',
    'skills-description': 'Principales herramientas y tecnologías utilizadas hasta el momento en el desarrollo de proyectos y soluciones.',
    'projects-title': 'Proyectos',
    'projects-description': 'Algunos proyectos desarrollados durante mi trayectoria como desarrollador.',
    'tcc-express-supermarket': 'TCC - Express Supermarket',
    'tcc-project-description': 'Sistema de comercio electrónico desarrollado como Trabajo de Fin de Curso, integrado con escáner de código de barras y localización de productos.',
    'key-features': 'Características Principales:',
    'feature-ecommerce': 'Sistema completo de comercio electrónico',
    'feature-barcode': 'Escáner de código de barras integrado',
    'feature-location': 'Sistema de localización de productos',
    'traitus-gamer': 'Traitus Gamer Landing Page',
    'traitus-description': 'Landing page moderna desarrollada con tecnologías frontend avanzadas, enfocada en rendimiento y experiencia de usuario.',
    'traitus-feature-1': 'CSS Grid y Flexbox para layouts responsivos',
    'traitus-feature-2': 'JavaScript ES6+ Vanilla sin dependencias',
    'traitus-feature-3': 'Sistema de internacionalización (3 idiomas)',
    'cs2-team-portfolio': 'CS2 - Integración de Team y Steam',
    'cs2-description': 'Plataforma completa para Counter-Strike 2 con integración en tiempo real de Steam API, visualización de inventarios de jugadores, mercado Steam con precios actualizados en BRL y sistema de audio inmersivo.',
    'cs2-feature-1': 'Mercado Steam en tiempo real con conversión USD→BRL',
    'cs2-feature-2': 'Visor de inventarios con datos reales de jugadores',
    'cs2-feature-3': 'Sistema de búsqueda avanzado con traducción al portugués',
    'cs2-feature-4': 'Interfaz moderna con navegación por pestañas y modales',
    'cs2-feature-5': 'Sistema de audio interactivo con efectos CS2',
    'weather-project': 'Pronóstico del Tiempo en Tiempo Real',
    'weather-description': 'Aplicación del clima con datos en tiempo real de Open-Meteo, búsqueda de ciudades con sugerencias instantáneas y fondo animado en WebGL que reacciona al clima actual: sol, lluvia, nieve, niebla y tormentas eléctricas.',
    'weather-feature-1': 'Fondo animado con Three.js (WebGL) según el clima y el viento',
    'weather-feature-2': 'Gráfico interactivo de temperatura y lluvia de las próximas 24h',
    'weather-feature-3': 'Búsqueda de ciudades con autocompletado en tiempo real',
    'weather-feature-4': 'Pronóstico de 14 días y mapa interactivo con Leaflet',
    'view-project': 'Ver Proyecto',
    'image-coming-soon': 'Imagen próximamente',
    'contact-title': 'Ponte en Contacto',
    'contact-description': '¡Hablemos sobre tu próximo proyecto!',
    'contact-us': 'Contáctame'
  }
};

export const languageConfig = {
  pt: { flag: '🇧🇷', text: 'PT', name: 'Português' },
  en: { flag: '🇺🇸', text: 'EN', name: 'English' },
  es: { flag: '🇪🇸', text: 'ES', name: 'Español' }
};

export default translations;